/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useState } from "react";
import { useSimpliCity } from "cms/hooks/use-simplicity";
import { DropdownMenu } from "./dropdown-menu";

const HeaderMenu = () => {

    const { menu } = useSimpliCity();
    const [currentDropdownMenu, setCurrentDropdownMenu] = useState(null);

    const handleMenuItemClick = (url) => {
        if (url === currentDropdownMenu) {
            setCurrentDropdownMenu(null);
        } else {
            setCurrentDropdownMenu(url);
        }
    };

    return (
        <div className="langley-header-menu">
            {menu.map((item, index) => {
                const childMenus = item?.children ?? [];
                const title = item?.title ?? "";
                const url = item?.url ?? "";
                const show = currentDropdownMenu === url;
                return (
                    <React.Fragment key={`menu-item-${index}`}>
                        <button
                            className='header-menu-item-level-1'
                            onClick={() => handleMenuItemClick(url)}
                        >
                            {title}
                        </button>
                        <DropdownMenu childMenus={childMenus} show={show} title={title} url={url} />
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export { HeaderMenu };
